import { Component, Input } from '@angular/core';
import { ActionSheetController, Events, ModalController, NavController, NavParams, PopoverController } from "ionic-angular";
import { NoShowModalPage } from "../../pages/no-show-modal/no-show-modal";
import { UserNotesModalPage } from "../../pages/user-notes-modal/user-notes-modal";
import { HttpClient } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { ServicesPage } from "../../pages/services/services";
import { ReschedulePage } from '../../pages/reschedule/reschedule';

/**
 * Generated class for the MoreOptionsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'more-options',
  templateUrl: 'more-options.html'
})
export class MoreOptionsComponent {
  @Input() canCancel: boolean;
  @Input() hideNoShow: boolean;
  @Input() barber: any;
  @Input() booking: any;
  @Input() index: number;
  @Input() currencySymbol: string;
  @Input() isFromQueue: boolean = false;

  errors: {};
  loading: boolean;
  tuid: string;
  teamId: string;
  options: Array<any>;
  option: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public modalCtrl : ModalController,
    public events: Events,
    private http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private actionSheetCtrl: ActionSheetController
  ) {
    this.tuid = localStorage.getItem('tuid');
    this.teamId = localStorage.getItem('currentTeamId');
   
    
  }

  showMoreOptions() {
    let actionSheet;
    let buttons = [
      {
        text: 'Customer Notes',
        handler: () => {
          actionSheet.dismiss().then(_ => {
            this.userNotesModal();
          });
          return false;
        }
      },
      {
        text: 'Add Additional Service',
        handler: () => {

          this.navCtrl.push(ServicesPage, {
            barber: this.barber,
            booking: this.booking,
            shop: { // the shop.id is required to get the shop on the services page api call
              id: this.booking.team_id
            },
            currencySymbol: this.currencySymbol,
            isAdditionalService: true
          });

        }
      },
      {
        text: 'Done',
        role: 'cancel',
        handler: () => {
          this.events.publish('myChair:more-option');
        }
      }
    ];

    if (this.canCancel) {
      buttons.unshift({
        text: 'Re-schedule',
        handler: () => {
          actionSheet.dismiss().then(_ => {
            this.reSchedule();
          });
          return false;
        }
      });
    }

    if (!this.hideNoShow) {
      buttons.unshift({
        text: 'No Show',
        handler: () => {
          actionSheet.dismiss().then(_ => {
            this.noShowModal();
          });
          return false;
        }
      });
    }

    if (this.canCancel) {
      buttons.unshift({
        text: 'Cancel Booking',
        handler: () => {
          actionSheet.dismiss().then(_ => {
            this.cancelModal();
          });
          return false;
        }
      });
    }

    actionSheet = this.actionSheetCtrl.create({
      buttons: buttons
    });

    actionSheet.present();

  }

  resetOptions(event: any) {
    this.option = null;
  }

  noShowModal() {
    let noShowModal = this.popoverCtrl.create(NoShowModalPage,
      {
        barber: this.barber,
        booking: this.booking,
        action: 'noShow'
      },
      {
        cssClass: 'no-show-modal',
        enableBackdropDismiss: false
      });

    noShowModal.present();

    noShowModal.onDidDismiss((booking) => {
      if (booking) {
        this.removeCancelledBooking(booking);
        this.events.publish('myChair:more-option');
      }
    })
  }

  cancelModal() {
    let cancelModal = this.popoverCtrl.create(NoShowModalPage,
      {
        barber: this.barber,
        booking: this.booking,
        action: 'cancel'
      },
      {
        cssClass: 'no-show-modal',
        enableBackdropDismiss: false
      });

    cancelModal.present();

    cancelModal.onDidDismiss((booking) => {
      if (booking) {
        this.removeCancelledBooking(booking);
        this.events.publish('myChair:more-option');
      }
    })
  }

  userNotesModal() {
    let userNotesModal = this.popoverCtrl.create(UserNotesModalPage,
      {
        barber: this.barber,
        booking: this.booking
      },
      {
        cssClass: 'user-notes-modal',
        enableBackdropDismiss: false
      });

    userNotesModal.present();

    // Update the note
    userNotesModal.onDidDismiss((res) => {
      if (res) {
        if (this.booking.booking.user.notes) {
          this.booking.booking.user.notes[0].note = res;
        }
      }
      this.events.publish('myChair:more-option');
    })
  }

  removeCancelledBooking(booking) {
    this.loading = true;
    this.getBarberWithBookings().then((barber: any) => {
      this.barber.todays_bookings = barber.todays_bookings;
      this.barber.todays_upcoming_advanced_bookings = barber.todays_upcoming_advanced_bookings;
      this.barber.upcoming_advanced_bookings = barber.upcoming_advanced_bookings;
      this.barber.todays_completed_bookings = barber.todays_completed_bookings;

      this.loading = false;
    });

    this.events.publish('myChair:badge');
  }

  sortCompletedBookings() {
    this.barber.todays_completed_bookings.sort((a, b) => a.estimated_booking_time >= b.estimated_booking_time ? -1 : 1);
  }

  getBarberWithBookings() {
    return new Promise((resolve, reject) => {
      this.http.get(`/teams/${this.teamId}/bookings/byStaff/${this.tuid}`).subscribe((barber: any) => {
        return resolve(barber);
      }, error => {
        this.errors = this.apiErrorHandler.handleError(error);
        return reject(this.errors);
      })
    })
  }

  reSchedule() {
    // let noShowModal = this.popoverCtrl.create(NoShowModalPage,
    //     {
    //         barber: this.barber,
    //         booking: this.booking,
    //         action: 'noShow'
    //     },
    //     {
    //         cssClass: 'no-show-modal',
    //         enableBackdropDismiss: false
    //     });

    let noShowModal = this.popoverCtrl.create(ReschedulePage, { isFromQueue: this.isFromQueue, booking: this.booking }, {
      cssClass: 're-schedule-booking-modal',
      enableBackdropDismiss: false
    });

    noShowModal.present();

    noShowModal.onDidDismiss((booking) => {
      if (booking) {
        this.removeCancelledBooking(booking);
        this.events.publish('myChair:more-option');
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/more-options/more-options.ts